const { createConstant } = require('../../helpers');

const service = 'market/customer';

module.exports = {
  GET_PRODUCTS_LIST_WITH_FILTERS: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_FILTERS'
  ),
  GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS'
  ),
  GET_PRODUCTS_LIST_WITH_FILTERS_ERROR: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_FILTERS_ERROR'
  ),
  GET_PRODUCTS_LIST_WITH_FILTERS_RESET: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_FILTERS_RESET'
  ),

  GET_PRODUCTS_LIST_WITHOUT_FILTERS: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITHOUT_FILTERS'
  ),
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS'
  ),
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR'
  ),
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET'
  ),

  GET_PRODUCTS_LIST_WITH_SEARCH: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_SEARCH'
  ),
  GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS'
  ),
  GET_PRODUCTS_LIST_WITH_SEARCH_ERROR: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_SEARCH_ERROR'
  ),
  GET_PRODUCTS_LIST_WITH_SEARCH_RESET: createConstant(
    service,
    'GET_PRODUCTS_LIST_WITH_SEARCH_RESET'
  ),

  GET_NEW_PRODUCT: createConstant(service, 'GET_NEW_PRODUCT'),
  GET_NEW_PRODUCT_SUCCESS: createConstant(service, 'GET_NEW_PRODUCT_SUCCESS'),
  GET_NEW_PRODUCT_ERROR: createConstant(service, 'GET_NEW_PRODUCT_ERROR'),
  GET_NEW_PRODUCT_RESET: createConstant(service, 'GET_NEW_PRODUCT_RESET'),

  GET_PRODUCT_CATEGORY: createConstant(service, 'GET_PRODUCT_CATEGORY'),
  GET_PRODUCT_CATEGORY_SUCCESS: createConstant(
    service,
    'GET_PRODUCT_CATEGORY_SUCCESS'
  ),
  GET_PRODUCT_CATEGORY_ERROR: createConstant(
    service,
    'GET_PRODUCT_CATEGORY_ERROR'
  ),
  GET_PRODUCT_CATEGORY_RESET: createConstant(
    service,
    'GET_PRODUCT_CATEGORY_RESET'
  ),

  GET_FEATURED_PRODUCT: createConstant(service, 'GET_FEATURED_PRODUCT'),
  GET_FEATURED_PRODUCT_SUCCESS: createConstant(
    service,
    'GET_FEATURED_PRODUCT_SUCCESS'
  ),
  GET_FEATURED_PRODUCT_ERROR: createConstant(
    service,
    'GET_FEATURED_PRODUCT_ERROR'
  ),
  GET_FEATURED_PRODUCT_RESET: createConstant(
    service,
    'GET_FEATURED_PRODUCT_RESET'
  ),

  GET_PARTICULAR_PRODUCTS: createConstant(service, 'GET_PARTICULAR_PRODUCTS'),
  GET_PARTICULAR_PRODUCTS_SUCCESS: createConstant(
    service,
    'GET_PARTICULAR_PRODUCTS_SUCCESS'
  ),
  GET_PARTICULAR_PRODUCTS_ERROR: createConstant(
    service,
    'GET_PARTICULAR_PRODUCTS_ERROR'
  ),
  GET_PARTICULAR_PRODUCTS_RESET: createConstant(
    service,
    'GET_PARTICULAR_PRODUCTS_RESET'
  ),

  GET_STORE_DETAILS: createConstant(service, 'GET_STORE_DETAILS'),
  GET_STORE_DETAILS_SUCCESS: createConstant(
    service,
    'GET_STORE_DETAILS_SUCCESS'
  ),
  GET_STORE_DETAILS_ERROR: createConstant(service, 'GET_STORE_DETAILS_ERROR'),
  GET_STORE_DETAILS_RESET: createConstant(service, 'GET_STORE_DETAILS_RESET'),

  GET_STORE_PRODUCT_LIST: createConstant(service, 'GET_STORE_PRODUCT_LIST'),
  GET_STORE_PRODUCT_LIST_SUCCESS: createConstant(
    service,
    'GET_STORE_PRODUCT_LIST_SUCCESS'
  ),
  GET_STORE_PRODUCT_LIST_ERROR: createConstant(
    service,
    'GET_CAGET_STORE_PRODUCT_LIST_ERRORRTS'
  ),
  GET_STORE_PRODUCT_LIST_RESET: createConstant(
    service,
    'GET_STORE_PRODUCT_LIST_RESET'
  ),

  GET_STORE_FEATURED_PRODUCT_LIST: createConstant(
    service,
    'GET_STORE_FEATURED_PRODUCT_LIST'
  ),
  GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS: createConstant(
    service,
    'GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS'
  ),
  GET_STORE_FEATURED_PRODUCT_LIST_ERROR: createConstant(
    service,
    'GET_STORE_FEATURED_PRODUCT_LIST_ERROR'
  ),
  GET_STORE_FEATURED_PRODUCT_LIST_RESET: createConstant(
    service,
    'GET_STORE_FEATURED_PRODUCT_LIST_RESET'
  ),
};
